<template>
  <div class="ctn">
    <div class="icon el-icon-s-platform"></div>
    <div class="name">{{sessionFile.Name}}</div>
    <div class="host">{{session.Host}}</div>
    <div class="port">{{session.Port}}</div>
    <div class="protocol">{{session.Protocol}}</div>
    <div class="user">{{session.User}}</div>
    <div class="desciption">{{session.Description}}</div>
  </div>
</template>

<script>
export default {
  name: "sessionLine",
  props: ["sessionFile"],
  computed: {
    session: function() {
      return JSON.parse(window.atob(this.sessionFile.Data))
    },
  },
}
</script>

<style scoped>
.ctn {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: baseline;
  text-align: left;
}
.icon {
  flex-grow: 0;
  flex-shrink: 0;
  margin-right: 6px;
}
.name {
  width: 12em;
  flex-grow: 0;
  flex-shrink: 0;

  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.host {
  width: 14em;
  flex-grow: 0;
  flex-shrink: 0;

  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.port {
  width: 4em;
  flex-grow: 0;
  flex-shrink: 0;
}
.protocol {
  width: 6em;
  flex-grow: 0;
  flex-shrink: 0;
}
.user {
  width: 6em;
  flex-grow: 0;
  flex-shrink: 0;

  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.description {
  width: 100%;
  flex-grow: 1;
  flex-shrink: 1;

  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>